import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	centerContent: {
		textAlign: "center",
	},
	buttonCenter: {
		justifyContent: "center",
	},
}));

export default function QuestionDialog({
	qHeading,
	qContent,
	qYes,
	qNo,
	answerHandler,
}) {
	const classes = useStyles();

	// Defaults to open
	const [open, setOpen] = useState(true);

	const handleClose = () => {
		setOpen(false);
	};

	const handleCloseYes = () => {
		setOpen(false);
		answerHandler("Yes");
	};

	const handleCloseNo = () => {
		setOpen(false);
		answerHandler("No");
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				disableBackdropClick={true}
				disableEscapeKeyDown={true}
				className={classes.centerContent}
			>
				<DialogTitle id="alert-dialog-title">{qHeading}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{qContent}
					</DialogContentText>
				</DialogContent>
				<DialogActions className={classes.buttonCenter}>
					<Button onClick={handleCloseYes} color="primary">
						{qYes}
					</Button>
					<Button onClick={handleCloseNo} color="primary">
						{qNo}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
